function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSubtracti = function SvgSubtracti(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M4 12a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSubtracti);
export default ForwardRef;